<template>
  <div class="py-12 bg-white">
    <div class="max-w-5xl mx-auto px-4">
      <!-- Header -->
      <div class="text-center mb-8">
        <h2 class="text-3xl font-bold mb-2">
          {{ content.title }}
        </h2>
        <p class="text-gray-600">
          {{ content.subtitle }}
          <a
            v-if="content.linkText"
            :href="content.linkUrl || '#'"
            class="text-primary font-semibold hover:underline ml-1"
          >
            {{ content.linkText }} &rarr;
          </a>
        </p>
      </div>

      <!-- Tabs -->
      <div class="flex flex-wrap justify-center gap-3 mb-8">
        <button
          v-for="(tab, index) in content.tabs"
          :key="index"
          class="px-6 py-2.5 rounded-full text-sm font-medium transition-colors flex-1 max-w-[220px]"
          :class="
            activeTab === index
              ? 'bg-primary text-white'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-200'
          "
          @click="activeTab = index"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Content -->
      <div class="text-center">
        <h3 class="text-xl font-bold mb-4">
          {{ currentTab.title }}
        </h3>
        <p class="text-gray-600 leading-relaxed max-w-3xl mx-auto">
          {{ currentTab.text }}
        </p>
      </div>

      <!-- CTA button -->
      <div class="mt-10 max-w-lg mx-auto">
        <JoszakiButton
          type="info"
          size="lg"
          expanded
          :to="localePath({ name: 'requestForTenderTab', params: { activeTab: 1 } })"
        >
          {{ $t("landing.howItWorks.ctaButton") }}
        </JoszakiButton>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, useContext } from "@nuxtjs/composition-api";
import useModuleContent from "~/composables/useModuleContent";

export default {
  name: "JobTipsModule",
  props: {
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { $posthog } = useContext();
    const { content } = useModuleContent(props);

    onMounted(() => {
      $posthog?.capture("front_page_module_viewed", {
        module_slug: props.moduleConfig.slug,
        module_position: props.moduleConfig.position,
        module_row: props.moduleConfig.row,
        version_id: props.moduleConfig.versionId,
      });
    });

    const activeTab = ref(0);
    const currentTab = computed(() => content.value.tabs[activeTab.value] || {});

    return {
      content,
      activeTab,
      currentTab,
    };
  },
};
</script>
